<div class="host-pay-invite">
  <div class="top">
    <div class="row">
      <div class="item" (click)="displayDetailsMdal()">
        <p class="subtitle">
          {{ 'upgrade.invite.invited_count' | translate }}
          <!-- 已邀请人数 -->
        </p>
        <p class="number">{{ overview?.invited_count }}</p>
      </div>
      <div class="item" (click)="displayDetailsMdal()">
        <p class="subtitle">
          {{ 'upgrade.invite.bonus_total' | translate }}
          <!-- 累计奖励金 -->
        </p>
        <p class="number">{{ overview?.total_reward_amount }}</p>
      </div>
      <div class="item" (click)="displayDetailsMdal()">
        <p class="subtitle">
          {{ 'upgrade.invite.bonus_balance' | translate }}
          <!-- 奖励金余额 -->
        </p>
        <p class="number">{{ overview?.reward_balance }}</p>
      </div>
      <div class="btn">
        <button nz-button (click)="applyForWithdrawal()">
          {{ 'upgrade.invite.cash_out' | translate }}
          <!-- 提现 -->
        </button>
        <p class="btn-tip">已提现¥{{ overview?.total_cash_out }}</p>
      </div>
    </div>
    <div class="tip">满10可提现到微信零钱，随时可用于内购。</div>
  </div>
  <div class="center">
    <div class="left"></div>
    <div class="center">
      <p class="title">
        邀请好友，
        <!-- {{ "upgrade.invite.title1" | translate }} -->
        <span class="strong">
          <!-- {{ "upgrade.invite.title2" | translate: {
            money: cashbackRate * 100
          } }} -->
          <!-- 返现奖励{{ (cashbackRate?.rate + cashbackRate?.rate_lv_2) * 100 | number : "1.0-0" }}% -->
          返现奖励25%
        </span>
      </p>
      <p class="tip">
        邀请的好友付款后，立即奖励好友付款金额的25%，可抵扣、可提现。
        <!-- 邀请的好友付款后，立即奖励{{ cashbackRate?.rate * 100 }}%；好友邀请的好友再付款，再奖励{{
          cashbackRate?.rate_lv_2 * 100
        }}%，可抵扣可提现。被邀请用户可获得优惠。 -->
      </p>
      <p class="check-rule" (click)="showRules = !showRules">
        查看具体规则<i nz-icon nzType="down" nzTheme="outline" *ngIf="!showRules"></i>
        <i nz-icon nzType="up" nzTheme="outline" *ngIf="showRules"></i>
      </p>
      <div class="rules" *ngIf="showRules">
        <p>1. 被邀请用户必须为新用户或超过60天未活跃且未处于付费期内的老用户。</p>
        <p>2. 被邀请的用户必须通过邀请码注册或登录。</p>
        <p>3. 被邀请的用户须在被邀请之日起30天内完成付费。</p>
        <p>4. 每用户仅可被邀请一次。本次活动暂未设置截止日期，如有相关信息将在本页面提供。</p>
        <p>
          5.
          禁止用户通过各种方式邀请自己以获取奖励金；被邀请用户使用其他优惠（如新人折扣券、现金券等）购买合约，邀请者不可获得奖励金；
        </p>
        <p>6. 邀请者必须为付费用户，且在邀请时持续正常使用，有明显的经营活动。</p>
        <p>7. 本活动不与其他活动同享；</p>
        <p>8.本次活动的最终解释权归属百居易。</p>
        <p>9. 本次活动所有奖品与苹果公司无关。</p>
      </div>

      <div class="invite-ways">
        <p class="invite-title">邀请好友</p>
        <div class="invite-item">
          <span class="invite-item-title">链接</span>
          <input nz-input style="width: 211px" [(ngModel)]="linkText" />
          <div class="copy" *ngIf="firstCopy" (click)="copy()" [attr.data-clipboard-text]="linkText">复制</div>
          <div class="checkin-copy" *ngIf="!firstCopy">复制</div>
        </div>
        <div class="invite-item">
          <span class="invite-item-title"> 图片 </span>
          <div class="view-invite" (click)="viewInviteImage()">电脑端查看</div>
          <div class="view-invite" (click)="viewInviteCode()">手机端查看</div>
        </div>
      </div>
    </div>
  </div>
  <div class="tip">
    {{ 'word.declaration' | translate }}
    <!-- 此活动的最终解释权归百居易所有 -->
  </div>
</div>

<ng-template #download>
  <div class="host-invite-modal-download-tpl">
    <img class="img" src="/assets/icon/download-qrcode-new.png" alt />
    <div class="tip">
      {{ 'component.invite.scan_to_download_app' | translate }}
      <!-- 请扫码下载百居易APP -->
    </div>
  </div>
</ng-template>

<ng-template #detail>
  <div class="host-invite-detail">
    <nz-table class="v4-layout-list" [nzData]="inviteDetailList" [nzShowPagination]="false" [nzFrontPagination]="false">
      <thead>
        <tr>
          <th>账号</th>
          <th>邀请结果</th>
          <th>奖励金</th>
          <th>受邀时间</th>
          <th>支付时间</th>
          <th>奖励比例</th>
          <th>邀请人</th>
        </tr>
      </thead>
      <tbody class="v4-layout-list-body">
        <tr *ngFor="let item of inviteDetailList">
          <td>{{ item?.account }}</td>
          <td>{{ getStatus(item?.invited_status) }}</td>
          <td>{{ item?.reward_amount ? item?.reward_amount : '-' }}</td>
          <td>{{ item?.invited_time }}</td>
          <td>{{ item?.payed_time ? item?.payed_time : '-' }}</td>
          <td>{{ item?.ratio * 100 }}%</td>
          <td>{{ item?.invited_creator }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</ng-template>

<ng-template #withdrawal>
  <nz-spin [nzSpinning]="withdrawalCodeLoading">
    <div class="host-invite-withdrawal">
      <p class="title">请扫码申请提现</p>
      <img [src]="withdrawalCodeUrl" />
      <p class="tip">如未关注公众号需点击关注</p>
      <p class="tip">款项将提现到您的微信零钱</p>
    </div>
  </nz-spin>
</ng-template>

<ng-template #inviteImage>
  <nz-spin [nzSpinning]="inviteImgLoading">
    <div class="host-invite-iamge">
      <img src="/api/member/friend_invitation/get_picture" />
      <p>直接将邀请函发送给好友</p>
    </div>
  </nz-spin>
</ng-template>

<ng-template #inviteCode>
  <nz-spin [nzSpinning]="inviteCodeLoading">
    <div class="host-invite-code">
      <P>请扫码在手机中查看</P>
      <img [src]="inviteQRCode" alt="code" />
    </div>
  </nz-spin>
</ng-template>
